import { PaginationBody } from '@Entities/pagination'
import { configuration } from '@App/configs'
import { base, paginationPath } from '@App/dicts/pathes'

export class Upload {
    files = (pagination: PaginationBody, rightsholderId: number) =>
        base(`upload/${rightsholderId}/file${paginationPath(pagination)}`)
    works = (rightsholderId: number, file?: number) => base(`upload/${rightsholderId}/works${file ? `/${file}` : ''}`)
    downloadTemplate = `${configuration.simple}/MLCBulkWork_V1.2.xlsx`
}
